import i18n from 'services/base/i18n';

export default {
  // Link to a page to change the maximum bandwidth settings for the network
  editBandwidth: () => i18n.pgettext('Pages|Bandwidth Prioritization', 'EDIT BANDWIDTH'),
  // Button to save the changes to the bandwidth prioritization
  save: () => i18n.pgettext('Pages|Bandwidth Prioritization', 'SAVE'),
};
